'use strict';

// external
import {keys} from 'ts-transformer-keys';

// shared imports
import {ItemAttributes} from '~/shared/src/ci/Item';
import {ReferenceAttributes} from '~/shared/src/ci/Reference';
import {BaseRequestParameters} from '~/shared/src/model/BaseRequest';
import {BusinessProcessStep} from '~/shared/src/utilities/businessProcessStep';
import {DataStructure} from '~/shared/src/utilities/dataStructure';


/*** MetaModel types *************************************************************************************************/

// CFG:BusinessProcess
export type BusinessProcess = {
    data : {
        id : number;
        key : string;
        name? : string;

        active : boolean;
        description? : string;
    };

    dataStructure? : DataStructure;
    steps? : ( BusinessProcessStep | BusinessProcessStep[] )[];
};
export const businessProcessDataProps = keys<BusinessProcess['data']>();
export const requiredBusinessProcessProps = keys<RequiredOf<BusinessProcess>>();
export const businessProcessProps = keys<BusinessProcess>();


/*** method types ****************************************************************************************************/

/*** loadConfig ***/
export type LoadConfigDataParameters = Partial<BaseRequestParameters> & ( {
    viewId : string;
    viewKey : string;
} );
export type LoadConfigDataResult = {
    success : boolean;
    data : {
        items : ItemAttributes[];
        references : ReferenceAttributes[];
    };
    metaData : {
        metrics : Metric[];

        // debug
        cypher? : string;
        sql? : string;
        parameters? : {
            [ parameter : string ] : any
        };
    };
};


export type GetBusinessProcessItemIdByDisplayAttributeParameters = {
    displayAttributeValue : string;
};
export type GetBusinessProcessItemIdByDisplayAttributeResult = {
    success : true;
    data : {
        rootItemId? : number;
    };
    metaData : {
        metrics : Metric[];

        // debug
        getBusinessProcessItemId? : {
            sql? : string;
            parameters? : {
                [ parameter : string ] : any
            };
        };
    };
};


export type GetViewKeyByNameParameters = {
    viewName : string;
};
export type GetViewKeyByNameResult = {
    success : true;
    data : {
        viewKey? : string;
    };
    metaData : {
        metrics : Metric[];

        // debug
        sql? : string;
        parameters? : { [ parameter : string ] : any };
    };
};

/*** deleteBusinessProcess ***/
export type DeleteBusinessProcessParameters = {
    viewId : number;
    historizeOnly? : boolean;
};
export type DeleteBusinessProcessResult = {
    success : boolean;
    metaData : {
        metrics : Metric[];
    }
};
